var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'moral-edit',
  created () {
    this.search()
    this.usertypeGet()
    this.guidelineGet()
  },
  data () {
    return {
      view: true,
      saveIndex: null,
      canValidate: true,
      searchCallbackFlag : false,
      usertypeGetCallbackFlag: false,
      guidelineGetCallbackFlag: false,
      upFlg: false,
      moral: {
        moral_title: null,
        moral_start_date: null,
        moral_end_date: null,
        reference_authority: null
      },
      localMorals: [],
      usertypeIds: [],
      savingFlag: false,
      allCheck: false
    }
  },
  computed: {
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    guidelines () {
      return this.$store.getters.guidelinesAll
    },
    moralEdit () {
      return this.$store.getters.moralEdit
    },
    moralEditDetail () {
      return this.$store.getters.moralEditDetail
    },
    moralEditTarget () {
      return this.$store.getters.moralEditTarget
    },
    validation: function () {
      var today = new Date()
      var v = {
        moral_title: !!this.moral.moral_title,
        moral_start_end: !!this.moral.moral_start_date && !!this.moral.moral_end_date &&
                         new Date(this.moral.moral_start_date.toString()).getTime() > today.getTime() && new Date(this.moral.moral_end_date.toString()).getTime() > today.getTime(),
        moral_start_end_range: !this.moral.moral_start_date || !this.moral.moral_end_date || new Date(this.moral.moral_start_date.toString()).getTime() <= new Date(this.moral.moral_end_date.toString()).getTime(),
        reference_authority: !!this.moral.reference_authority,
        usertypeIds: this.usertypeIds.length > 0,
        not_input: !!this.moral.moral_title &&
                   !!this.moral.moral_start_date &&
                   !!this.moral.moral_end_date &&
                   new Date(this.moral.moral_start_date.toString()).getTime() <= new Date(this.moral.moral_end_date.toString()).getTime() &&
                   new Date(this.moral.moral_start_date.toString()).getTime() > today.getTime() &&
                   new Date(this.moral.moral_end_date.toString()).getTime() > today.getTime() &&
                   !!this.moral.reference_authority &&
                   this.usertypeIds.length > 0

      }

      v.check_content = []
      v.check_image = []
      v.sub_title = []
      v.guideline_id = []
      v.check_content_all = true
      v.check_image_all = true
      v.sub_title_all = true
      v.guideline_id_all = true
      for (var index in this.localMorals) {
        var vc = (this.localMorals[index].check_content) ? true : false
        v.check_content.push(vc)
        v.check_content_all &= vc

        var vi = (this.localMorals[index].check_image) ? true : false
        v.check_image.push(vi)
        v.check_image_all &= vi

        var vs = (this.localMorals[index].sub_title) ? true : false
        v.sub_title.push(vs)
        v.sub_title_all &= vs

        var vg = (this.localMorals[index].guideline_id) ? true : false
        v.guideline_id.push(vg)
        v.guideline_id_all &= vg
      }

      v.not_input = v.not_input &&
                    !!v.check_content.length &&
                    !!v.sub_title.length &&
                    !!v.guideline_id.length &&
                    !!v.check_content_all &&
                    !!v.check_image_all &&
                    !!v.sub_title_all &&
                    !!v.guideline_id_all

      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    start_date: function() {
      var parseDate = new Date(this.moral.moral_start_date.toString())
      return parseDate.getFullYear() + '-' + ("0" + (parseDate.getMonth() + 1)).slice(-2) + '-' + ("0" + parseDate.getDate()).slice(-2)
    },
    end_date: function() {
      var parseDate = new Date(this.moral.moral_end_date.toString())
      return parseDate.getFullYear() + '-' + ("0" + (parseDate.getMonth() + 1)).slice(-2) + '-' + ("0" + parseDate.getDate()).slice(-2)
    },
    uploadSuccess() {
      return this.$store.getters.moralImageUploadSuccess
    },
    uploadError() {
      return this.$store.getters.moralImageUploadError
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    usertypeGet: function() {
      var self = this
      var callback = function (){
        self.usertypeGetCallbackFlag = true
      }
      this.$store.dispatch('USERTYPE_ALL_GET', {callback: callback})
    },
    guidelineGet: function() {
      var self = this
      var callback = function (){
        self.guidelineGetCallbackFlag = true
      }
      this.$store.dispatch('GUIDELINE_ALL_GET', {callback: callback})
    },
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true

        self.moral.moral_title = self.moralEdit['moral-title']
        self.moral.moral_start_date = self.moralEdit['moral-start-date']
        self.moral.moral_end_date = self.moralEdit['moral-end-date']
        self.moral.reference_authority = self.moralEdit['reference-authority']

        for (var i=0; i < self.moralEditDetail.length; i++) {
          var morals = {
            moral_detail_id: self.moralEditDetail[i].id,
            check_content: self.moralEditDetail[i].attributes['check-content'],
            check_image: self.moralEditDetail[i].attributes['check-image-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp,
            sub_title: self.moralEditDetail[i].attributes['sub-title'],
            guideline_id: self.moralEditDetail[i].attributes['guideline-id'],
            yes_answer_add: self.moralEditDetail[i].attributes['yes-answer-add'],
            no_answer_add: self.moralEditDetail[i].attributes['no-answer-add']
          }
          self.localMorals.push(morals)
          self.contentCounter(i)
        }

        for (var i=0; i < self.moralEditTarget.length; i++) {
          self.usertypeIds.push(self.moralEditTarget[i].attributes['user-type-id'])
        }

      }
      this.$store.dispatch('MORAL_EDIT', { id: this.$route.params.id, data: data, callback: callback })
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        this.searchCallbackFlag = false
        this.moral.moral_start_date = this.start_date
        this.moral.moral_end_date = this.end_date

        console.log("is valid")
        var data = {
          'moral': this.moral,
          'moral_detail': this.localMorals,
          'moral_target': this.usertypeIds
        }
        this.$store.dispatch('MORAL_UPDATE',
          { data: data, callback: this.onSaved, id: this.$route.params.id, errorCallback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push('/moral_list')
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/moral_list')
    },
    addMoral: function (index) {
      var morals = {
        check_content: '',
        check_content_count: 0,
        check_image: '',
        sub_title: '',
        guideline_id: '',
        yes_answer_add: '',
        no_answer_add: ''
      }
      this.localMorals.splice(index+1, 0, morals)
    },
    deleteMoral: function (index) {
      this.localMorals.splice(index, 1)
    },
    indexSave: function(index) {
      this.saveIndex = index
      this.upFlg = false
      this.reset()
    },
    onDragOver: function (index, event) {
      console.log('onDragOver')
      event.preventDefault()
    },
    onDrop: function (index, event) {
      console.log('onDrop')
      event.preventDefault()
      var files = event.target.files || event.dataTransfer.files
      this.upload(index, files[0])
    },
    onFileChange: function (index, event) {
      console.log('onFileChange')
      var files = event.target.files || event.dataTransfer.files
      this.upload(index, files[0])
    },
    upload: function (index, file) {
      this.upFlg = true
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        self.localMorals[index].image_data = e.target.result
        var formData = new FormData()
        formData.append('moral_image', file)
        self.$store.dispatch('MORAL_IMAGE_UPLOAD', { data: formData, index: index, callback: self.onUpload })
      }
      reader.readAsDataURL(file)
    },
    onUpload: function (index, data) {
      this.localMorals[index].check_image = data.image_path + '?token=' + this.authToken
      this.uploadFlg = true
    },
    /** 画像押下 */
    onClickImageModalShow: function (index) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.localMorals[index].check_image
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    reset () {
      this.view = false
      this.$nextTick(function () {
        this.view = true
      })
    },
    contentCounter: function(index) {
      this.localMorals[index].check_content_count = this.localMorals[index].check_content.length
    },
    targetAllCheck: function () {
      this.usertypeIds = []
      if (this.allCheck) {
        for (var i=0; i < this.usertypes.length; i++) {
          this.usertypeIds.push(this.usertypes[i].id)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-edit.js